import { Redirect, Route, Switch } from 'react-router-dom';
import { NotFound } from '@/pages/not-found';
import { AiReportPage } from '@/pages/report';

export const AppRoutes = () => (
  <Switch>
    <Route exact path="/404" component={NotFound} />
    <Route exact strict path="/report/:studyFid/:profileId" component={AiReportPage} />
    <Route path="*">
      <Redirect to="/404" />
    </Route>
  </Switch>
);
